import React from 'react';
import Modal from 'shared/components/modal';
import Address from 'shared/account-settings/components/address-verification-modals/address';
import {AddressForm} from 'src/types/onboarding';
import {useFormikContext} from 'formik';

interface Props {
  onUpdate?: () => void;
  confirmationText?: string;
}

export default function CannotVerifyAddressModal({confirmationText, onUpdate}: Props) {
  const form = useFormikContext<AddressForm>();

  function tryAgain(): void {
    form.setFieldTouched('addressLine1');
    form.setFieldError('addressLine1', 'We could not verify your address. Please try again.');
    form.setValues({
      ...form.values,
      city: '',
      subdivision: '',
      postalCode: '',
      _addressSuggestion: undefined,
    });
  }

  function confirmOriginalAddress(): void {
    form.setValues({
      ...form.values,
      addressVerified: false,
      confirmedUnverifiedAddress: true,
      countyName: '',
      countyFips: '',
      _addressSuggestion: undefined,
    });

    console.log('Confirming original address');

    onUpdate?.();
  }

  return (
    <Modal show className="address-verification-modal">
      <Modal.TextHeader onClose={tryAgain}>Double-check your address</Modal.TextHeader>

      <Modal.Body>
        <p className="address-verification-modal-problem-text">
          There&apos;s a problem with the address provided. Please make sure it&apos;s correct
          before saving.
        </p>
        <Address type="Original" address={form.values} />
        <hr aria-hidden="true" />
        <h5 className="address-type">Suggested Address</h5>
        <p className="address-verification-modal-cannot-verify-address-text">
          We couldn&apos;t verify your address. Please try again.
        </p>
      </Modal.Body>

      <Modal.Footer
        primaryButton={{
          text: 'Try Again',
          onClick: tryAgain,
          cy: 'cannotverify-tryagain',
        }}
        secondaryButton={{
          text: confirmationText || 'Confirm Original Address',
          onClick: confirmOriginalAddress,
          rightAligned: true,
          cy: 'cannotverify-confirm',
        }}
      />
    </Modal>
  );
}
